import cn from 'classnames';
import { forwardRef } from 'react';

export interface CheckboxInputProps {
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  disabled?: boolean;
  label?: string;
  size?: 'sm' | 'md' | 'lg';
  color?: 'primary' | 'secondary';
  className?: string;
}

export const CheckboxInput = forwardRef<HTMLInputElement, CheckboxInputProps>(
  ({ checked, onChange, disabled, label, size = 'lg', color = 'primary', className }, ref) => {
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      if (onChange) {
        onChange(event.target.checked);
      }
    };

    const wrapperClasses = cn('form-check', 'form-check-solid', 'form-check-custom', {
      'form-check-sm': size === 'sm',
      'form-check-lg': size === 'lg',
      'form-check-primary': color === 'primary',
      'form-check-secondary': color === 'secondary'
    });

    return (
      <div className={cn(wrapperClasses, className)}>
        <input
          ref={ref}
          type="checkbox"
          className="form-check-input"
          checked={checked}
          onChange={handleChange}
          disabled={disabled}
        />
        {label && <label className="form-check-label">{label}</label>}
      </div>
    );
  }
);

CheckboxInput.displayName = 'CheckboxInput';
